class BundleBuilder {
  constructor() {
    this.bundleLimit = 0;
    this.selectedItems = new Map();
    this.shippingPrice = 0;
    this.init();
  }

  init() {
    const bundleBuilder = document.querySelector('.bundle-builder');
    if (!bundleBuilder) return;

    this.bundleLimit = parseInt(bundleBuilder.dataset.bundleLimit);
    this.attachEventListeners();
    this.updateCounter();
  }

  attachEventListeners() {
    // Quantity buttons
    document.querySelectorAll('.bundle-qty-btn').forEach(btn => {
      btn.addEventListener('click', (e) => this.handleQuantityChange(e));
    });

    // Shipping selector
    const shippingSelect = document.querySelector('[data-bundle-shipping]');
    if (shippingSelect) {
      shippingSelect.addEventListener('change', (e) => this.handleShippingChange(e));
    }

    // Checkout button
    const checkoutBtn = document.querySelector('[data-bundle-checkout]');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', () => this.handleCheckout());
    }
  }

  handleQuantityChange(e) {
    const btn = e.currentTarget;
    const action = btn.dataset.action;
    const itemContainer = btn.closest('.bundle-product-item');
    const input = itemContainer.querySelector('.bundle-qty-input');
    const currentValue = parseInt(input.value);
    const variantId = input.dataset.variantId;
    const productTitle = input.dataset.productTitle;
    const productPrice = parseFloat(input.dataset.productPrice);

    let newValue = currentValue;

    if (action === 'increase') {
      const totalSelected = this.getTotalSelected();
      if (totalSelected < this.bundleLimit) {
        newValue = currentValue + 1;
      }
    } else if (action === 'decrease' && currentValue > 0) {
      newValue = currentValue - 1;
    }

    if (newValue !== currentValue) {
      input.value = newValue;
      
      // Update selection map
      if (newValue > 0) {
        this.selectedItems.set(variantId, {
          quantity: newValue,
          title: productTitle,
          price: productPrice
        });
        itemContainer.classList.add('selected');
      } else {
        this.selectedItems.delete(variantId);
        itemContainer.classList.remove('selected');
      }

      this.updateCounter();
      this.updateSubtotal();
      this.updateButtons();
    }
  }

  getTotalSelected() {
    let total = 0;
    this.selectedItems.forEach(item => {
      total += item.quantity;
    });
    return total;
  }

  updateCounter() {
    const current = this.getTotalSelected();
    const counterCurrent = document.querySelector('.bundle-counter__current');
    const counterMessage = document.querySelector('.bundle-counter__message');
    const counter = document.querySelector('.bundle-counter');

    // Update all progress badges
    document.querySelectorAll('[data-bundle-progress]').forEach(badge => {
      const currentSpan = badge.querySelector('[data-progress-current]');
      if (currentSpan) {
        currentSpan.textContent = current;
        
        // Add visual states
        badge.classList.toggle('complete', current === this.bundleLimit);
        badge.classList.toggle('near-limit', current >= this.bundleLimit - 1 && current < this.bundleLimit);
      }
    });

    if (counterCurrent) {
      counterCurrent.textContent = current;
    }

    if (counterMessage && counter) {
      if (current < this.bundleLimit) {
        const remaining = this.bundleLimit - current;
        counterMessage.textContent = `Please select ${remaining} more to proceed`;
        counter.classList.remove('complete');
      } else {
        counterMessage.textContent = 'Ready to proceed!';
        counter.classList.add('complete');
      }
    }

    this.validateCheckout();
  }

  updateSubtotal() {
    let subtotal = 0;
    this.selectedItems.forEach(item => {
      subtotal += item.price * item.quantity;
    });

    const subtotalElement = document.querySelector('.bundle-subtotal__amount');
    if (subtotalElement) {
      subtotalElement.textContent = this.formatMoney(subtotal);
    }

    this.updateTotal();
  }

  updateButtons() {
    const totalSelected = this.getTotalSelected();
    
    // Disable plus buttons if limit reached
    document.querySelectorAll('.bundle-qty-btn--plus').forEach(btn => {
      btn.disabled = totalSelected >= this.bundleLimit && 
                      btn.closest('.bundle-product-item').querySelector('.bundle-qty-input').value === '0';
    });
  }

  handleShippingChange(e) {
    const selectedOption = e.target.selectedOptions[0];
    if (selectedOption && selectedOption.value) {
      this.shippingPrice = parseFloat(selectedOption.dataset.price) / 100;
      this.updateTotal();
      this.validateCheckout();
    }
  }

  updateTotal() {
    const totalElement = document.querySelector('.bundle-total__amount');
    if (!totalElement) return;

    if (this.shippingPrice === 0) {
      totalElement.textContent = '--';
      return;
    }

    let subtotal = 0;
    this.selectedItems.forEach(item => {
      subtotal += item.price * item.quantity;
    });

    const total = subtotal + this.shippingPrice;
    totalElement.textContent = this.formatMoney(total);
  }

  validateCheckout() {
    const checkoutBtn = document.querySelector('[data-bundle-checkout]');
    if (!checkoutBtn) return;

    const totalSelected = this.getTotalSelected();
    const shippingSelected = document.querySelector('[data-bundle-shipping]')?.value;
    
    checkoutBtn.disabled = !(totalSelected === this.bundleLimit && shippingSelected);
  }

  handleCheckout() {
    const totalSelected = this.getTotalSelected();
    const shippingSelect = document.querySelector('[data-bundle-shipping]');
    
    if (totalSelected !== this.bundleLimit || !shippingSelect?.value) {
      return;
    }

    // Show loading state
    const checkoutBtn = document.querySelector('[data-bundle-checkout]');
    checkoutBtn.disabled = true;
    checkoutBtn.textContent = 'Preparing checkout...';
    
    // Build items array for cart
    const items = [];
    
    // Add the MAIN BUNDLE PRODUCT first
    const bundleVariantId = checkoutBtn.dataset.bundleVariantId;
    if (bundleVariantId) {
      items.push({
        id: parseInt(bundleVariantId),
        quantity: 1
      });
    }
    
    // Add selected bundle items
    this.selectedItems.forEach((item, variantId) => {
      items.push({
        id: parseInt(variantId),
        quantity: item.quantity
      });
    });
    
    // Add shipping option
    items.push({
      id: parseInt(shippingSelect.value),
      quantity: 1
    });

    // Add all bundle items to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items })
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to add items to cart');
      }
      return response.json();
    })
    .then(() => {
      // Redirect to checkout
      window.location.href = '/checkout';
    })
    .catch(error => {
      console.error('Checkout error:', error);
      checkoutBtn.disabled = false;
      checkoutBtn.textContent = 'Proceed to Secure Checkout';
      
      // Show user-friendly error
      alert('There was an issue preparing your checkout. Please try again or contact support if the problem persists.');
    });
  }

  formatMoney(cents) {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: 'CAD'
    }).format(cents);
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new BundleBuilder();
  });
} else {
  new BundleBuilder();
}